export class CustomField {
  constructor ({ code, value }) {
    this.code = code
    this.value = value
  }
}
